export default "__VITE_PUBLIC_ASSET__9f2c199e__"